import React from 'react';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import { SearchSettingsConfig } from 'searchkit';
import { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import { SEARCHKIT_HOST_URL, APP_OPTIONS } from '../../../../config/constants';

const searchSettings: SearchSettingsConfig = {
  search_attributes: ['title', 'body'],
  result_attributes: ['title', 'body', 'latlon', 'project_status', 'project_type', 'url', 'nid'],
  facet_attributes: [
    {
      attribute: 'project_status',
      field: 'project_status',
      type: 'string',
    },
    {
      attribute: 'project_type',
      field: 'project_type',
      type: 'string',
    },
  ],
  sorting: {
    default: {
      field: 'title',
      order: 'asc',
    },
  },
};

// Omit all the properties that get added in this component.
// Any other properties may be passed here as restProps.
type ProjectMapSearchkitWrapperProps = Omit<
SearchkitWrapperProps,
'connection' | 'searchSettings' | 'indexName'
>;

const ProjectMapSearchkitWrapper: React.FC<ProjectMapSearchkitWrapperProps> = (props) => {
  const {
    children,
    ...restProps
  } = props;

  return (
    <SearchkitWrapper
      {...restProps}
      connection={{
        host: SEARCHKIT_HOST_URL,
      }}
      indexName={APP_OPTIONS?.parameters.searchkitIndexAllProjects}
      searchSettings={searchSettings}
    >
      {children}
    </SearchkitWrapper>
  );
};

export default ProjectMapSearchkitWrapper;
